import { render, staticRenderFns } from "./prenotazioneNre.vue?vue&type=template&id=5002290b"
import script from "./prenotazioneNre.vue?vue&type=script&lang=js"
export * from "./prenotazioneNre.vue?vue&type=script&lang=js"
import style0 from "./prenotazioneNre.vue?vue&type=style&index=0&id=5002290b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports